<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class ServiceBase extends Vue {
        @Prop({required: true}) order
        @Prop() serviceTips
        @Prop() orderEndDate
        @Prop() variantsAvailable

        isInfoLoading = false
        infoLoadingFinished = false
        isMinimized = null

        async minimizedChange(val) {
            this.isMinimized = val

            if (!this.infoLoadingFinished && !this.isInfoLoading && this.isMinimized === false) {
                await this.loadProductInfo()
            }
        }

        showInfo() {
            if (this.$refs.serviceInfoDialog) {
                this.$refs.serviceInfoDialog.customProductInfoMode = false
            }

            if (!this.infoLoadingFinished) {
                this.loadProductInfo()
            }

            this.modal = true
        }

        async loadProductInfo() {
            this.infoLoadingFinished = true
        }

        get orderId() {
            return this.order.orderId
        }

        get objectId() {
            return this.order.objectId
        }
    }

    export default ServiceBase
</script>
